import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/quotation-generator`;

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export const qgApi = {
  list: (q) => axios.get(`${API}/quotations`, { headers: auth(), params: q ? { q } : {} }).then((r) => r.data),
  create: (body) => axios.post(`${API}/quotations`, body, { headers: auth() }).then((r) => r.data),
  get: (id) => axios.get(`${API}/quotations/${id}`, { headers: auth() }).then((r) => r.data),
  save: (id, body) => axios.put(`${API}/quotations/${id}`, body, { headers: auth() }).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/quotations/${id}`, { headers: auth() }).then((r) => r.data),
  duplicate: (id, quotation_number) => axios.post(`${API}/quotations/${id}/duplicate`, { quotation_number }, { headers: auth() }).then((r) => r.data),
  finalize: (id) => axios.post(`${API}/quotations/${id}/finalize`, {}, { headers: auth() }).then((r) => r.data),
  newRevision: (id) => axios.post(`${API}/quotations/${id}/new-revision`, {}, { headers: auth() }).then((r) => r.data),
  revisions: (id) => axios.get(`${API}/quotations/${id}/revisions`, { headers: auth() }).then((r) => r.data),
  pdfBlob: (id, revision) =>
    axios.get(`${API}/quotations/${id}/pdf`, { headers: auth(), params: revision === undefined || revision === null ? {} : { revision }, responseType: "blob" })
      .then((r) => r.data),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/images`, fd, { headers: auth() }).then((r) => r.data);
  },
  imageBlob: (imageId) => axios.get(`${API}/images/${imageId}`, { headers: auth(), responseType: "blob" }).then((r) => r.data),
};

export const errorMessage = (err, fallback = "Something went wrong") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  return fallback;
};

export const STATUS_META = {
  not_started: { label: "Not started", dot: "bg-slate-300", text: "text-slate-500" },
  in_progress: { label: "In progress", dot: "bg-amber-400", text: "text-amber-700" },
  complete: { label: "Complete", dot: "bg-emerald-500", text: "text-emerald-700" },
  not_applicable: { label: "Not applicable", dot: "bg-slate-400 ring-2 ring-slate-200", text: "text-slate-500" },
};

export const sectionCode = (sections, key) => {
  const sec = sections.find((s) => s.key === key);
  if (!sec) return "";
  const idx = sections.filter((s) => s.section === sec.section).findIndex((s) => s.key === key);
  return `${sec.section}${idx + 1}`;
};
